import { IconButtonBadgeWrapper } from './IconButton.styles'
import { BadgeProps } from './IconButton.types'

const IconButtonBadge = ({
  value,
  className = '',
  color = 'primary',
  styles,
  children,
  ...props
}: BadgeProps) => {
  return (
    <IconButtonBadgeWrapper
      className={`IconButtonBadge ${className}`}
      badgeContent={value}
      color={color}
      sx={styles}
      {...props}>
      {children}
    </IconButtonBadgeWrapper>
  )
}

export default IconButtonBadge
